import * as React from 'react';
import styled from '@emotion/styled';
import { StaticQuery, graphql } from 'gatsby';
import GitHubButton from 'react-github-btn';
import Link from './link';
import Loadable from 'react-loadable';
import * as Unicons from '@iconscout/react-unicons';
import config from '../../config.js';
import LoadingProvider from './mdxComponents/loading';
import { Link as Links } from 'gatsby';

const help = require('./images/help.svg');

const isSearchEnabled = config.header.search && config.header.search.enabled ? true : false;

let searchIndices = [];

if (isSearchEnabled && config.header.search.indexName) {
  searchIndices.push({
    name: `${config.header.search.indexName}`,
    title: `Results`,
    hitComp: `PageHit`,
  });
}

import Sidebar from './sidebar';

const LoadableComponent = Loadable({
  loader: () => import('./search/index'),
  loading: LoadingProvider,
});

const StyledBgDiv = styled('div')`
  height: 60px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #f8f8f8;
  position: relative;
  display: none;
  background: white;

  @media (max-width: 767px) {
    display: block;
  }
`;

const Header = ({ location, isDarkThemeActive, toggleActiveTheme }) => {
  const [open, setOpen] = React.useState(false);
  function myFunction() {
    var x = document.getElementById('navbar');

    if (x.className === 'topnav') {
      x.className += ' responsive';
    } else {
      x.className = 'topnav';
    }
    setOpen((prev) => !prev);
  }
  return (
    <>
      <div className={'navBarWrapper'}>
        <nav className={'navBarDefault'}>
          <div className="navWrap">
            <div className="inputWrapper">
              <Unicons.UilSearch size={20} style={{ margin: '5px' }} />
              <input type="text" placeholder="Search documentation" className="inputElement" />
            </div>
            <div
              className="navBarToggle"
              onClick={myFunction}
              onKeyDown={myFunction}
              role="button"
              tabIndex={0}
              style={{ position: `${open ? 'fixed' : 'absolute'}` }}
            >
              {!open ? (
                <Unicons.UilBars size={30} style={{ color: '#7b68e3' }} />
              ) : (
                <Unicons.UilTimes size={30} style={{ color: '#7b68e3' }} />
              )}
            </div>
            <div className="buttonWrapper">
              <a href="https://dashboard.zevi.ai/login" target="_blank" className="login">
                <button className="login buttons">Log in</button>
              </a>
              <a href="https://dashboard.zevi.ai/signup" target="_blank" className="signup">
                <button className="signup buttons">Sign up</button>
              </a>
            </div>
          </div>
          <div id="navbar" className={'topnav'}>
            <div className={'visibleMobile'}>
              <Sidebar location={location} />
              {/* <hr /> */}
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
